import { atom } from "recoil";
import { IOfficeAppliancesType } from "../types";

const PREFIX = "officeAppliancesType";

export const addStateOfficeAppliancesType = atom<boolean>({
  key: `${PREFIX}/addState`,
  default: false,
});

export const editStateOfficeAppliancesType = atom<boolean>({
  key: `${PREFIX}/editState`,
  default: false,
});

export const rowEditOfficeAppliancesType = atom<
  IOfficeAppliancesType | null
>({
  key: `${PREFIX}/rowEdit`,
  default: null,
});

export const officeAppliancesTypeFilterText = atom<string>({
  key: `${PREFIX}/filterText`,
  default: "",
});

export const selectedRowsStateOfficeAppliancesType = atom<
  IOfficeAppliancesType[]
>({
  key: `${PREFIX}/selectedRows`,
  default: [],
});

export const officeAppliancesTypeFetching = atom<boolean>({
  key: `${PREFIX}/isFetching`,
  default: true,
});

export const officeAppliancesTypeSaving = atom<boolean>({
  key: `${PREFIX}/isSaving`,
  default: false,
});